export const applyArtisanatFilters = (annonce, filters) => {
  const { typeArt = [], ville = [], prixMin, prixMax } = filters;

  const isTypertFiltered =
    typeArt.length === 0 ||
    typeArt.includes(annonce.typeArt);

  const isVilleFiltered =
    ville.length === 0 || ville.includes(annonce.etat);

  const isPrixFiltered =
    (!prixMin || annonce.prix >= parseFloat(prixMin)) &&
    (!prixMax || annonce.prix <= parseFloat(prixMax));

  return isTypertFiltered && isVilleFiltered && isPrixFiltered;
};
